import { createReducer, on } from "@ngrx/store";
import { Notification } from "../notification";
import { NotificationActions } from "./actions";

export interface INotificationState {
  notification: Notification;
  error: string;
}

const initialState: INotificationState = {
  notification: null,
  error: ""
};

export const notificationReducer = createReducer<INotificationState>(
  initialState,
  on(
    NotificationActions.showNotification,
    (state, action): INotificationState => {
      return {
        ...state,
        notification: action.notification,
        error: ""
      };
    }
  ),
  on(
    NotificationActions.showNotificationFailure,
    (state, action): INotificationState => {
      return {
        ...state,
        error: action.error
      };
    }
  ),
  on(
    NotificationActions.showNotificationSuccess,
    (state, action): INotificationState => {
      return {
        ...state,
        notification: action.notification
      };
    }
  )
);
